import { capabilities } from 'navigation-components/capabilities';
import { useCapability } from 'navigation-components/platform/hooks';
import { useCallback, useEffect, useState } from 'react';
export const useNavComponentSearchInputEventHandler = () => {
  const [route, setRoute] = useState(null);
  const {
    subscribe
  } = useCapability(capabilities.SEARCH_INPUT_EVENT_CAP.getName());
  const handleSearchInputEvent = useCallback(({
    name,
    value
  }) => {
    switch (name) {
      case 'changeRoute':
        {
          setRoute(value.location);
          break;
        }
      default:
        break;
    }
  }, []);
  useEffect(() => {
    return subscribe(handleSearchInputEvent);
  }, [handleSearchInputEvent, subscribe]);
  return {
    route
  };
};